import React from 'react';

function Urd() {
  return (
    <div>
     Urðr - ᚢᚱᚦ - “That which has become”
    </div>
  );
}

export default Urd;